import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.wheelOfFortuneLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.wheelOfFortuneLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.wheelOfFortuneLevels.data.wheelOfFortuneLevels,
  (collections = []) => collections
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
